import React from 'react';

function Delivery() {
  return (
    <>
      <h2 className="font-bold text-center p-3 " id="delivery"> Доставка і оплата</h2>
      <div className="p-3"> 
      <p className="pb-1 font-size">Ви можете скористатись наступними способами доставки товару:</p>
      <ul>
        <li>Самовивіз з магазину - м. Одеса, вул. Буніна буд.22.</li>
        <li> Відправка транспортною компанією на склад ТК або за вашою адресою: Нова Пошта, Укрпошта (за тарифами перевізника).
      Замовлення відправляємо протягом 1-3 днів.</li>
      </ul>
      <p className="pb-1 font-size">Оплатити замовлення можна наступними способами:</p>
      <ul>
        <li>Оплата готівкою в магазині в м. Одеса (вул. Буніна, 12).</li>
        <li>Переказ коштів на карту/рахунок українського банку. При виборі цього способу оплати менеджер особисто надасть актуальні
        реквізити.</li>
        <li>Післяплата (оплата при отриманні «Нова Пошта») + 2% до загальної суми за сервіс Нової Пошти. Оплата цим способом
      можлива, при предоплаті в розмірі 140 грн</li>
      <li>Оплата онлайн через сервіс Wayforpay. Виберіть можливість оплати Wayforpay під час оформлення замовлення. Після
      перевірки даних про замовлення, ви перейдете на сторінку платіжної системи. Оплата онлайн відбувається на сторінках,
      захищених сертифікатами безпеки. Для цього ми використовуємо офіціний сервіс оплат Wayforpay з технологією захисту даних
      в Інтернет мережі.
      </li>
      </ul>
      <p className="pb-1 font-size">Оформлення замовлення</p>
      <p>
      Після замовлення на сайті з Вами зв’яжеться наш менеджер. Узгодить всі деталі та допоможе правильно підібрати розмір.
      Після цього замовлення буде доставлено в обумовлені терміни (як правило 1-2 дні). Ви будете мати змогу відстежити
      замовлення по номеру товарно-транспортної накладної, який буде відправлено на вказаний при оформленні замовлення номер
      телефону.</p>
    </div>
</>
  );  
}

export default Delivery;